import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=86604a72&scoped=true"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Basic.vue?vue&type=style&index=0&id=86604a72&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "86604a72",
  null
  ,true
)

export default component.exports